import { Middleware } from 'redux'
import { FormDispatch, FormRootState, FormThunk } from './formStore'
import _ from 'lodash'
import { AnyConceptStatusesByCid, FusionError } from '@fusion-advantage/backcompat'
import { ConceptStatusUpdate } from '@fusion-advantage/formlib'
import { submitStatusUpdates } from './submitStatusUpdates'
import { ComplexModelReduxPersister } from '../lib/formmodel/ComplexModelReduxPersister'
import { err, ok, Result } from 'neverthrow'

export class FormModelPersistMiddleware {
	private _registry: ComplexModelReduxPersister[] = []
	register(persister: ComplexModelReduxPersister[]) {
		this._registry.push(...persister)
	}
	loadFromStatuses = (statusesByCid: AnyConceptStatusesByCid): FormThunk<Result<void, FusionError>> => (dispatch) => {
		for(let persister of this._registry) {
			let rLoad = dispatch(persister.loadFromStatuses(statusesByCid))
			if(rLoad.isErr()) {
				return err(rLoad.error)
			}
		}
		return ok()
	}
	middleware: Middleware<{}, FormRootState> = store => {
		const dispatch = store.dispatch as FormDispatch
		return next => action => {
			const prevState = store.getState()
			const result = next(action)
			const nextState = store.getState()
			const statusUpdates: ConceptStatusUpdate[] = []
			for(let persister of this._registry) {
				if(!persister.shouldSave(prevState, nextState)) {
					continue
				}
				statusUpdates.push(
					...persister.createStatusUpdates(nextState),
				)
			}
			if(statusUpdates.length > 0) {
				dispatch(submitStatusUpdates(statusUpdates))
			}
			return result
		}
	}
}
